module.exports = __webpack_public_path__ + "static/media/HelveticaNow-CondensedBold.ef591ead.ttf";